import React from 'react';
import {Box, Typography, CircularProgress} from '@mui/material';

const LoadingScreen = ({message = 'Carregando dados atualizados...'}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                gap: 1.5,
            }}
        >
            <CircularProgress />
            <Typography variant="h6" color="text.secondary">
                {message}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Aguarde um instante...
            </Typography>
        </Box>
    );
};

export default LoadingScreen;
